<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableNodeDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="success"
          size="small"
          v-hasPermission="['approvalFlowConfiguration:node:log']"
          @click="rowClick(row)"
          >{{ $t("configuration_management.common.operationLog") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="nodeDelmodal = true"
            v-hasPermission="['approvalFlowConfiguration:node:delete']"
            >{{ $t("configuration_management.common.deleteButton") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除模式框 -->
    <Modal v-model="nodeDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ name }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeNode()"
          :disabled="isDisable"
          >{{ $t("ticket.list.delete") }}
        </Button>
      </div>
    </Modal>
    <Modal
      v-model="nodeEditModal"
      :title="this.$t('approvalFlowConfigManagement.Node.editNode')"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      @on-ok="nodeSubmit('nodeEditForm')"
      @on-cancel="nodeReset('nodeEditForm')"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="nodeEditForm"
        :model="nodeEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 节点名称 -->
        <FormItem
          :label="$t('approvalFlowConfigManagement.Node.nodeName')"
          prop="nodeName"
        >
          <Input v-model="nodeEditForm.nodeName" style="width:300px;"></Input>
        </FormItem>

        <!-- 类型 -->
        <FormItem
          :label="$t('approvalFlowConfigManagement.Node.type')"
          prop="type"
        >
          <Select
            v-model="nodeEditForm.type"
            style="width:300px;"
            @on-change="changeType(nodeEditForm.type)"
            :placeholder="$t('configuration_management.common.pleaseSelect')"
          >
            <Option
              :value="item.id"
              v-for="item in typeList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <div v-if="isCompany">
          <!-- 公司 -->
          <FormItem
            :label="$t('approvalFlowConfigManagement.approvalFlow.companyName')"
            prop="companyId"
          >
            <Select
              v-model="nodeEditForm.companyId"
              style="width:300px;"
              @on-change="changeCompany(nodeEditForm.companyId)"
              :placeholder="$t('configuration_management.common.pleaseSelect')"
            >
              <Option
                :value="item.id"
                v-for="item in companyIdList"
                v-bind:key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <div v-if="isUser">
          <!-- 用户 -->
          <FormItem
            :label="$t('approvalFlowConfigManagement.Node.user')"
            prop="owner"
          >
            <Select
              v-model="nodeEditForm.owner"
              style="width:300px;"
              :placeholder="$t('configuration_management.common.pleaseSelect')"
            >
              <Option
                :value="item.id"
                v-for="item in ownerList"
                v-bind:key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <div v-if="isRole">
          <!-- 角色 -->
          <FormItem
            :label="$t('approvalFlowConfigManagement.Node.role')"
            prop="role"
          >
            <Select
              v-model="nodeEditForm.role"
              style="width:300px;"
              :placeholder="$t('configuration_management.common.pleaseSelect')"
            >
              <Option
                :value="item.id"
                v-for="item in roleList"
                v-bind:key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

var tableNodeVue = {};
export default {
  name: "TableNode",
  components: {
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      isShowOperationLog: false,
      isUser: false,
      isRole: false,
      isCompany: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      nodeEditModal: false,
      loading: true,
      val: "",
      companyIdVal: "",
      name: "",
      nodeEditForm: {
        nodeName: "",
        type: "",
        owner: "",
        role: "",
        companyId: ""
      },
      typeList: [
        {
          id: 0,
          name: this.$t("approvalFlowConfigManagement.Node.user")
        },
        {
          id: 1,
          name: this.$t("approvalFlowConfigManagement.Node.role")
        }
      ],
      companyIdList: [],
      ownerList: [],
      roleList: [],
      modal_loading: false, //删除
      nodeDelmodal: false,
      isDisable: false,
      ruleValidate: {
        nodeName: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.Node.nodeNameNotEmpty"
            ),
            trigger: "blur"
          },
          {
            type: "string",
            message: this.$t(
              "approvalFlowConfigManagement.Node.nodeNameValidateMsg"
            ),
            pattern: "^.{4,20}$",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.Node.pleaseSelectNodeType"
            ),
            trigger: "change",
            type: "number"
          }
        ],
        owner: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.Node.pleaseSelectUser"
            ),
            trigger: "change",
            type: "number"
          }
        ],
        role: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.Node.pleaseSelectRole"
            ),
            trigger: "change",
            type: "number"
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.Node.pleaseSelectCompany"
            ),
            trigger: "change",
            type: "number"
          }
        ]
      },
      columns: [
        {
          title: this.$t("approvalFlowConfigManagement.Node.nodeName"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.nodeEditForm.id = params.row.id;
                    this.nodeEditModal = true;
                    // 节点名称
                    this.nodeEditForm.nodeName = params.row.name;
                    // 公司
                    tableNodeVue.getCompanyDropDownBox();
                    this.nodeEditForm.companyId = params.row.companyId;
                    this.nodeEditForm.type = params.row.type;
                    // 类型是用户、角色
                    if (params.row.type == 0) {
                      this.isUser = true;
                      this.isRole = false;
                      // 用户
                      tableNodeVue.changeCompany();
                      this.nodeEditForm.owner = params.row.owner;
                    } else if (params.row.type == 1) {
                      this.isUser = false;
                      this.isRole = true;
                      // 角色
                      tableNodeVue.changeCompany();
                      this.nodeEditForm.role = params.row.role;
                    }
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t("approvalFlowConfigManagement.Node.nodeType"),
          key: "typeName"
        },
        {
          title: this.$t("approvalFlowConfigManagement.Node.companyName"),
          key: "companyName"
        },
        {
          title: this.$t("approvalFlowConfigManagement.Node.user"),
          key: "ownerName"
        },
        {
          title: this.$t("approvalFlowConfigManagement.Node.role"),
          key: "roleName"
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableNodeDate: []
    };
  },
  beforeCreate: function() {
    tableNodeVue = this;
  },
  mounted: function() {
    tableNodeVue.getNodeData();
  },
  methods: {
    // 切换类型
    changeType: function() {
      if (this.nodeEditForm.type == 0) {
        this.isUser = true;
        this.isRole = false;
        this.isCompany = true;
      } else if (this.nodeEditForm.type == 1) {
        this.isUser = false;
        this.isRole = true;
        this.isCompany = true;
      }
      this.changeCompany();
    },
    //公司下拉框
    getCompanyDropDownBox: function() {
      this.nodeEditForm.companyId = "";
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyIdList = res.data;
        });
    },
    // 切换公司
    changeCompany: function() {
      if (this.nodeEditForm.companyId == undefined) {
        return;
      } else {
        if (this.isRole) {
          this.nodeEditForm.role = "";
          this.$api.user
            .queryRole("companyId", this.nodeEditForm.companyId)
            .then(res => {
              this.roleList = res.data;
            });
        }
        if (this.isUser) {
          this.nodeEditForm.owner = "";
          this.$api.user
            .queryUserByCompanyId("companyId", this.nodeEditForm.companyId)
            .then(res => {
              this.ownerList = res.data;
            });
        }
        if (this.isCompany) {
          this.nodeEditForm.role = "";
          this.nodeEditForm.owner = "";
        }
      }
    },
    showAll: function() {
      tableNodeVue.getNodeData();
    },
    // 分页显示数据
    /****************************************************/
    getNodeData: function() {
      // 获取nodeSearch里面的搜索内容
      eventBus.$on("nodeName", function(val) {
        tableNodeVue.val = val;
      });
      eventBus.$on("companyIdVal", function(companyIdVal) {
        tableNodeVue.companyIdVal = companyIdVal;
      });
      //分页
      this.$api.processNode
        .pageProcessNode({
          name: tableNodeVue.val,
          companyId: tableNodeVue.companyIdVal,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableNodeDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableNodeVue.getNodeData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableNodeVue.getNodeData();
    },
    // 销毁nodeSearch
    beforeDestroy: function() {
      eventBus.$off("nodeName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.name = this.tableNodeDate[index].name;
    },
    removeNode: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.processNode
        .deleteProcessNode("id", this.tableNodeDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableNodeVue.showAll();
            this.isDisable = false;
            this.modal_loading = false;
            this.nodeDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 编辑节点
    /*************************************************************************/
    // 确定
    nodeSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var updateDate = {
            id: this.nodeEditForm.id,
            name: this.nodeEditForm.nodeName,
            type: this.nodeEditForm.type
          };
          if (this.nodeEditForm.type == 0) {
            updateDate.owner = this.nodeEditForm.owner;
          } else if (this.nodeEditForm.type == 1) {
            updateDate.role = this.nodeEditForm.role;
            updateDate.companyId = this.nodeEditForm.companyId;
          }
          // 编辑节点
          this.$api.processNode.updateProcessNode(updateDate).then(res => {
            setTimeout(() => {
              tableNodeVue.showAll();
              this.$refs[name].resetFields();
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.$Message.success(this.$t("common.editSuccess"));
              this.nodeEditModal = false;
              this.isUser = false;
              this.isCompany = false;
              this.isRole = false;
            }, 1000);
          });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    // 取消
    nodeReset: function(name) {
      this.nodeEditModal = false;
      this.isUser = false;
      this.isCompany = false;
      this.isRole = false;
      this.$refs[name].resetFields();
      this.companyIdList = [];
      this.ownerList = [];
      this.roleList = [];
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          13
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/node/TableNode.vue